import { render, staticRenderFns } from "./first-visit-box.vue?vue&type=template&id=aa5dce60&"
import script from "./first-visit-box.vue?vue&type=script&lang=js&"
export * from "./first-visit-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports